import { render, staticRenderFns } from "./YrReport.vue?vue&type=template&id=07bffc9e&scoped=true&lang=html&"
import script from "./YrReport.vue?vue&type=script&lang=js&"
export * from "./YrReport.vue?vue&type=script&lang=js&"
import style0 from "./YrReport.vue?vue&type=style&index=0&id=07bffc9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bffc9e",
  null
  
)

export default component.exports